// document.addEventListener("DOMContentLoaded", function () {

//     const triggerButton = document.querySelector('.mw-secondary-menu__trigger');
//     const siteLogo = document.querySelector('.mw-site-logo');
//     const searchButton = document.querySelector('.mw-search-button');

//     if (triggerButton) {
//         triggerButton.addEventListener('click', () => {
//             const isExpanded = triggerButton.getAttribute("aria-expanded") !== "false";
//             const controlElement = document.getElementById(triggerButton.getAttribute('aria-controls'));
//             const classCloseBtn = 'mw-secondary-menu__close-btn';

//             if (controlElement) {
//                 if (isExpanded) {
//                     triggerButton.classList.remove(classCloseBtn);
//                     controlElement.classList.remove('active');
//                     if (siteLogo) {
//                         siteLogo.classList.remove('active');
//                     }
//                     if (searchButton) {
//                         searchButton.style.display = 'inline-flex';
//                     }
//                 } else {
//                     triggerButton.classList.add(classCloseBtn);
//                     controlElement.classList.add('active');
//                     if (siteLogo) {
//                         siteLogo.classList.add('active');
//                     }
//                     if (searchButton) {
//                         searchButton.style.display = 'none';
//                     }
//                 }
//                 triggerButton.setAttribute("aria-expanded", !isExpanded);
//             }
//         });
//     }

//     // --- Gestion largeur niveau 1 (miroir du primary) ---
//     const setParentLevel1WidthForElement = (el, open) => {
//         const parentLvl1Menu = el.closest(".mw-secondary-menu__wrapper--level-1");
//         if (!parentLvl1Menu) return;

//         const li = el.closest('li');
//         if (open) {
//             if (!li) {
//                 parentLvl1Menu.style.width = '';
//                 return;
//             }
//             if (li.classList.contains('mw-secondary-menu__item--level-2')) {
//                 parentLvl1Menu.style.width = '800px';
//             } else if (li.classList.contains('mw-secondary-menu__item--level-3')) {
//                 parentLvl1Menu.style.width = '995px';
//             } else {
//                 parentLvl1Menu.style.width = '';
//             }
//             return;
//         }

//         if (!li) {
//             parentLvl1Menu.style.width = '';
//             return;
//         }

//         if (li.classList.contains('mw-secondary-menu__item--level-3')) {
//             parentLvl1Menu.style.width = '800px';
//             return;
//         }

//         if (li.classList.contains('mw-secondary-menu__item--level-2')) {
//             parentLvl1Menu.style.width = '';
//             return;
//         }

//         parentLvl1Menu.style.width = '';
//     };

//     // --- Boutons sous-menus ---
//     const buttons = document.querySelectorAll(".mw-secondary-menu__item button");

//     buttons.forEach(button => {
//         button.addEventListener("click", function (event) {
//             event.stopPropagation();

//             const subMenuId = this.getAttribute("aria-controls");
//             const subMenu = document.getElementById(subMenuId);
//             const isOpen = this.getAttribute("aria-expanded") === "true";
//             const parentLi = this.closest("li");

//             // Ferme uniquement les sous-menus du même niveau
//             const parentMenu = this.closest(".mw-secondary-menu__wrapper") || document;
//             parentMenu.querySelectorAll(".mw-secondary-menu__wrapper").forEach(menu => {
//                 if (menu !== subMenu) {
//                     menu.style.display = "none";
//                     menu.previousElementSibling?.setAttribute("aria-expanded", "false");

//                     const otherLi = menu.closest("li");
//                     if (otherLi) {
//                         otherLi.classList.remove("is-open");
//                     }
//                 }
//             });

//             // Toggle du menu actuel
//             if (!isOpen) {
//                 subMenu.style.display = "block";
//                 this.setAttribute("aria-expanded", "true");
//                 if (parentLi) {
//                     parentLi.classList.add("is-open");
//                     setParentLevel1WidthForElement(this, true);
//                 }
//             } else {
//                 subMenu.style.display = "none";
//                 this.setAttribute("aria-expanded", "false");
//                 if (parentLi) {
//                     parentLi.classList.remove("is-open");
//                     setParentLevel1WidthForElement(this, false);
//                 }
//             }
//         });
//     });

//     // Fermer tout le menu si on clique en dehors
//     document.addEventListener("click", function (event) {
//         if (!event.target.closest(".mw-secondary-menu")) {
//             document.querySelectorAll(".mw-secondary-menu__wrapper:not(.mw-secondary-menu__wrapper--level-0)").forEach(menu => {
//                 menu.style.display = "none";
//             });

//             document.querySelectorAll(".mw-secondary-menu__item button").forEach(btn => {
//                 btn.setAttribute("aria-expanded", "false");
//             });
//         }
//     });

// });